import i18n from 'i18next'
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n.use(HttpApi) //.use(LanguageDetector)
  .use(initReactI18next)
	.init({
		fallbackLng: 'de_CH',

		backend: {
			// path where resources get loaded from
			loadPath: '/_Resources/Static/Packages/Visol.AblCh/Locales/{{lng}}/{{ns}}.json?1668697142',
		},

		// have a common namespace used around the full app
		ns: ['common'],
		defaultNS: 'common',

		//debug: true,

		interpolation: {
			escapeValue: false // not needed for react!!
		}
	})


export default i18n;
